import copy from "clipboard-copy";
import PropTypes from "prop-types";

export const LinkPushCommunityComponent = ({ communityLink, handleChange }) => {
  return (
    <div className="input-with-copy">
      <img alt="link" src="/img/new-icons/link.svg" className="mobile-hidden" />
      <input
        placeholder="Paste link here.."
        name="communityLink"
        onChange={handleChange}
        value={communityLink}
        type="text"
        className="text-input"
      />
      <div className="force-mobile-hidden">
        <button
          data-button-type="secondary"
          data-icon
          data-icon-only
          className="mobile-hidden"
          onClick={async (e) => {
            e.preventDefault();
            await copy(communityLink);
          }}
        >
          <img alt="copy" src="/img/new-icons/copy.svg" />
        </button>
      </div>
    </div>
  );
};

LinkPushCommunityComponent.propTypes = {
  communityLink: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};
